<template>
	<ClientOnly>
		<v-layout class="mega-menu-mobile">
			<v-navigation-drawer
				v-model="isMobileMenuOpen"
				:width="width"
				touchless
				temporary
				location="right"
				class="mega-menu-mobile__drawer-container">
				<v-window v-model="tab" class="profile-menu__tab-content">
					<v-window-item value="menu">
						<div class="mega-menu-mobile__content">
							<div class="mega-menu-mobile__buttons-container">
								<GlobalLanguageSelect big />
								<CurrencySelect />
							</div>
							<div class="mega-menu-mobile__menu mega-menu-mobile__menu--main">
								<ButtonCustom
									v-for="(item, index) in computedNav"
									:key="index"
									:to="item.newTab === true ? undefined : localePath(item.to)"
									:href="item.newTab === true ? item.to : undefined"
									class="mega-menu-mobile__main-menu-link"
									:target="item.newTab === true ? '_blank' : ''"
									@click="item.type === 'dropdown' ? (tab = 'mega_menu') : undefined">
									<div>
										{{ i18nService.$tDynamic('components.nav', item.translation_key_label || item.label) }}
									</div>
									<GlobalIcon
										v-if="item.type === 'dropdown'"
										name="arrow-right"
										:height="18"
										:width="18"
										class="mega-menu-mobile__menu-link-icon" />
								</ButtonCustom>
								<div class="mega-menu-mobile__ratings-and-buttons">
									<div class="mega-menu-mobile__socials-container">
										<div class="mega-menu-mobile__fb-ig">
											<NuxtLink
												class="mega-menu-mobile__social-container"
												to="https://www.facebook.com/CarFree.Wypozyczalnia.Aut"
												rel="nofollow"
												target="_blank">
												<GlobalIcon name="facebook" :height="24" :width="24" color="var(--primary-color)" />
											</NuxtLink>
											<NuxtLink
												class="mega-menu-mobile__social-container"
												to="https://www.instagram.com/carfree.wypozyczalnia"
												rel="nofollow"
												target="_blank">
												<GlobalIcon name="instagram" :height="24" :width="24" color="var(--primary-color)" />
											</NuxtLink>
											<NuxtLink
												class="mega-menu-mobile__social-container"
												to="https://www.tiktok.com/@carfree.pl"
												rel="nofollow"
												target="_blank">
												<GlobalIcon name="tiktok" :height="24" :width="24" color="var(--primary-color)" />
											</NuxtLink>
										</div>
										<NuxtLink
											v-if="ratingsForm.stars && ratingsForm.stars !== ''"
											class="mega-menu-mobile__google-container"
											:to="ratingsForm?.url"
											rel="nofollow"
											target="_blank">
											<div class="mega-menu-mobile__social-container">
												<GlobalIcon name="google-logo" :height="24" :width="24" />
											</div>
											<div class="mega-menu-mobile__ratings-box">
												<div class="mega-menu-mobile__ratings">
													<div class="mega-menu-mobile__rating-text">{{ ratingsForm.ratings }}</div>
													<div class="mega-menu-mobile__rating-stars">
														<GlobalRating
															:rating="ratingsForm.stars"
															readonly
															colorFilled="var(--primary-color)"
															colorEmpty="var(--primary-color)"></GlobalRating>
													</div>
												</div>
												<div class="mega-menu-mobile__google-and-amount">
													<div class="mega-menu-mobile__google-text">Google,</div>
													<div class="mega-menu-mobile__google-amount">
														{{ ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
													</div>
												</div>
											</div>
										</NuxtLink>
									</div>
									<div class="mega-menu-mobile__buttons">
										<ButtonPrimary class="mega-menu-mobile__start-reservation-btn" :to="localePath('cars')">
											{{ $t('components.mega_menu.mobile.start_reservation') }}
										</ButtonPrimary>
									</div>
								</div>
							</div>
						</div>
					</v-window-item>
					<v-window-item value="mega_menu">
						<div class="mega-menu-mobile__content">
							<div class="mega-menu-mobile__back-container">
								<button class="mega-menu-mobile__back-btn" @click="handleBack">
									<GlobalIcon name="arrow-left" :height="14" :width="14" class="mega-menu-mobile__back-icon" />
									<div class="mega-menu-mobile__back-text">{{ $t('components.mega_menu.mobile.back') }}</div>
								</button>
							</div>
							<div class="mega-menu-mobile__menu">
								<template v-for="(section, l) in computedMenu" :key="l">
									<div v-if="l !== 0" class="mega-menu-mobile__divider"></div>
									<div class="mega-menu-mobile__menu-title">
										{{ i18nService.$tDynamic('components.nav.mega_menu', section.translation_key_title || section.title) }}
									</div>
									<div class="mega-menu-mobile__menu-links">
										<div v-for="(menuItem, j) in computedMenu[l].items" :key="j" class="mega-menu-mobile__menu-link-container">
											<ButtonCustom
												:to="menuItem?.link && !menuItem?.items && !menuItem?.menu ? localePath(menuItem?.link) : undefined"
												class="mega-menu-mobile__menu-link"
												@click="handleSubmenu(menuItem)">
												<GlobalIcon
													v-if="menuItem.icon"
													:name="menuItem.icon"
													:height="18"
													:width="18"
													color="var(--primary-color)"
													class="mega-menu-mobile__menu-link-main-icon" />
												<div class="mega-menu-mobile__menu-link-info">
													<div class="mega-menu-mobile__menu-link-text">
														{{
															i18nService.$tDynamic(
																'components.nav.mega_menu',
																menuItem.translation_key_title || menuItem.title,
															)
														}}
													</div>
													<div v-if="menuItem.subText" class="mega-menu-mobile__menu-link-subtext">
														{{
															i18nService.$tDynamic(
																'components.nav.mega_menu',
																menuItem.translation_key_subText || menuItem.subText,
															)
														}}
													</div>
												</div>
												<GlobalIcon
													v-if="(menuItem.items && menuItem.items.length > 0) || menuItem.menu"
													name="arrow-right"
													:height="18"
													:width="18"
													class="mega-menu-mobile__menu-link-icon" />
											</ButtonCustom>
										</div>
									</div>
								</template>
							</div>
						</div>
					</v-window-item>
					<v-window-item value="sub_items">
						<div class="mega-menu-mobile__content">
							<div class="mega-menu-mobile__back-container">
								<button class="mega-menu-mobile__back-btn" @click="handleBack">
									<GlobalIcon name="arrow-left" :height="14" :width="14" class="mega-menu-mobile__back-icon" />
									<div class="mega-menu-mobile__back-text">{{ $t('components.mega_menu.mobile.back') }}</div>
								</button>
							</div>
							<div v-if="selectedMenuItem" class="mega-menu-mobile__menu">
								<div class="mega-menu-mobile__menu-link-container">
									<ButtonCustom
										:to="
											selectedMenuItem?.link === 'electric-cars'
												? pathForElectric
												: localePath(selectedMenuItem?.link) || undefined
										"
										class="mega-menu-mobile__menu-link">
										<div class="mega-menu-mobile__menu-link-info">
											<div class="mega-menu-mobile__submenu-link-text">
												{{
													`${i18nService.$tDynamic('components.nav.mega_menu', selectedMenuItem.translation_key_title || selectedMenuItem.title)}`
												}}
											</div>
										</div>
									</ButtonCustom>
								</div>

								<div class="mega-menu-mobile__menu-links mega-menu-mobile__menu-links--subitems">
									<div v-for="(menuItem, j) in selectedMenuItem.items" :key="j" class="mega-menu-mobile__menu-link-container">
										<ButtonCustom
											:to="menuItem?.link ? localePath(menuItem?.link) : undefined"
											class="mega-menu-mobile__menu-link"
											@click="handleSubitemClick(menuItem)">
											<div class="mega-menu-mobile__menu-link-info">
												<div class="mega-menu-mobile__submenu-link-text">
													{{
														i18nService.$tDynamic(
															'components.nav.mega_menu',
															menuItem.translation_key_title || menuItem.title,
														)
													}}
												</div>
											</div>
										</ButtonCustom>
									</div>
									<template v-if="areCustomItems(selectedMenuItem.translation_key_title)">
										<div
											v-for="menuItem in customItems"
											:key="menuItem.translation_key_title"
											class="mega-menu-mobile__menu-link-container">
											<ButtonCustom
												:to="menuItem.to || undefined"
												class="mega-menu-mobile__menu-link"
												@click="handleSubitemClick(menuItem)">
												<div class="mega-menu-mobile__menu-link-info">
													<div class="mega-menu-mobile__submenu-link-text">
														{{
															i18nService.$tDynamic(
																'components.nav.mega_menu',
																menuItem.translation_key_title || menuItem.title,
															)
														}}
													</div>
												</div>
											</ButtonCustom>
										</div>
									</template>
								</div>
							</div>
						</div>
					</v-window-item>
				</v-window>
			</v-navigation-drawer>
		</v-layout>
	</ClientOnly>
</template>

<script setup lang="ts">
import {
	busesIDs,
	deliveryBusesIDs,
	airportsIDs,
	branchesIDs,
	busesIDsEN,
	deliveryBusesIDsEN,
	airportsIDsEN,
	branchesIDsEN,
	nav,
	megaMenuData,
	megaMenuDataEN,
} from '@/data/megaMenuData'

const tab = ref()
const isMobileMenuOpen = inject<Ref<boolean>>('isMobileMenuOpen') || ref(false)
const selectedMenuItem = ref<IMegaMenuItem | null>(null)
const i18nService = usei18nService()
const localePath = useLocalePath()
const { locale } = useI18n()
const googleRatingsStore = useGoogleRatingsStore()
const { width } = useWindowSize()
const carRentalStore = useCarRentalStore()
const CMSLocationsStore = useCMSLocationsStore()
const CMSLocations = ref<ICMSLocationModel[] | undefined>(undefined)

const computedMenu = computed(() => {
	return locale.value === 'pl' ? megaMenuData : megaMenuDataEN
})

const computedNav = computed(() => {
	return nav
		.map((item) => {
			if (item.translation_key_label === 'frequent_questions') {
				return { ...item, to: `https://intercom-help.eu/carfree/${locale.value === 'en' ? 'en' : 'pl'}/` }
			}
			return item
		})
		.filter((item) => (item?.showOnlyOnPL ? locale.value === 'pl' : true))
})

const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const pathForElectric = computed(() => {
	return localePath({ name: 'car-rental-urlSlug', params: { urlSlug: locale.value === 'pl' ? 'elektrycznych' : 'electric' } })
	// return '/pl/wypozyczalnia-samochodow-elektrycznych'
})

await googleRatingsStore.fetchGoogleRating()

const areCustomItems = (key: string) => {
	return key === 'bus_rental' || key === 'cities' || key === 'airports' || key === 'delivery_van_rental'
}

const customItems = computed(() => {
	if (!selectedMenuItem.value) return []
	if (selectedMenuItem.value.translation_key_title === 'bus_rental') return busesData.value
	if (selectedMenuItem.value.translation_key_title === 'cities') return branchesData.value
	if (selectedMenuItem.value.translation_key_title === 'airports') return airportsData.value
	if (selectedMenuItem.value.translation_key_title === 'delivery_van_rental') return deliveryBusesData.value
	return []
})

watch(
	() => CMSLocationsStore.getCMSLocations,
	(newValue) => {
		if (newValue) {
			CMSLocations.value = newValue
		}
	},
	{
		immediate: true,
		deep: true,
	},
)

const sortCustomMenuItems = (
	itemsToSort: ICMSLocationModel[],
	placesIDsArray: {
		id: string
		translation_key_title: string
	}[],
) => {
	const sortedItems = placesIDsArray.map((place) => {
		const foundItem = itemsToSort.find((item) => item.placeId === place.id)
		return { ...foundItem, translation_key_title: place.translation_key_title }
	})

	if (!sortedItems || sortedItems.length === 0) return []

	const formattedItems = sortedItems?.map((item) => ({
		to: getURLforLocation(item),
		translation_key_title: item.translation_key_title,
	}))

	formattedItems.push({
		to: localePath('locations'),
		translation_key_title: 'see_all_locations',
	})
	return formattedItems
}

const getURLforLocation = (item: ICMSLocationModel & { translation_key_title: string }) => {
	const urlLocale = item[`isActive${locale.value.toUpperCase()}`] ? item[`url${locale.value.toUpperCase()}`] : undefined
	const url = item.urlPL

	if (!url && !urlLocale) return undefined
	else
		return urlLocale
			? localePath({ name: 'car-rental-urlSlug', params: { urlSlug: urlLocale } }, locale.value)
			: localePath({ name: 'car-rental-urlSlug', params: { urlSlug: url } }, 'pl')
}

const busesData = computed(() => {
	const buses = CMSLocations.value?.filter(
		(l) =>
			(l.icon === 'location-bold' || (l.icon !== 'location-bold' && l.icon !== 'airplane')) &&
			l.showInMenu &&
			l.isActivePL &&
			!l.urlPL.includes('dostawczy'),
	)
	if (!buses || buses.length === 0) return []
	const busesIDsTemp = locale.value === 'pl' ? busesIDs : busesIDsEN
	return sortCustomMenuItems(buses, busesIDsTemp)
})

const deliveryBusesData = computed(() => {
	const deliveryBuses = CMSLocations.value?.filter(
		(l) => l.icon === 'location-bold' && l.showInMenu && l.isActivePL && l.urlPL.includes('dostawczy'),
	)
	if (!deliveryBuses || deliveryBuses.length === 0) return []
	const deliveryBusesIDsTemp = locale.value === 'pl' ? deliveryBusesIDs : deliveryBusesIDsEN
	return sortCustomMenuItems(deliveryBuses, deliveryBusesIDsTemp)
})

const airportsData = computed(() => {
	const airports = CMSLocations.value?.filter((l) => l.icon === 'airplane' && l.showInMenu && l.isActivePL)
	if (!airports || airports.length === 0) return []
	const airportsIDsTemp = locale.value === 'pl' ? airportsIDs : airportsIDsEN
	return sortCustomMenuItems(airports, airportsIDsTemp)
})

const branchesData = computed(() => {
	const branches = CMSLocations.value?.filter((l) => l.icon !== 'airplane' && l.showInMenu && l.isActivePL)
	if (!branches || branches.length === 0) return []
	const branchesIDsTemp = locale.value === 'pl' ? branchesIDs : branchesIDsEN
	return sortCustomMenuItems(branches, branchesIDsTemp)
})

watch(
	() => googleRatingsStore.getGoogleRating,
	(v) => {
		if (v) {
			ratingsForm.stars = v.stars
			ratingsForm.ratings = v.ratings
			ratingsForm.ratingsCount = v.ratingsCount
			ratingsForm.url = v.url
		}
	},
	{ immediate: true },
)

const handleSubmenu = (menuItem: IMegaMenuItem) => {
	if ((menuItem.items && menuItem.items.length > 0) || menuItem.menu) {
		tab.value = 'sub_items'
		selectedMenuItem.value = menuItem
	} else {
		carRentalStore.setRangeValue(1)
	}
}

const handleSubitemClick = (menuItem: IMegaMenuItem) => {
	switch (menuItem.link) {
		case '2months':
			carRentalStore.setRangeValue(2)
			break
		case '3months':
			carRentalStore.setRangeValue(3)
			break
		case '6months':
			carRentalStore.setRangeValue(6)
			break
		default:
			carRentalStore.setRangeValue(1)
			break
	}
}

const handleBack = () => {
	if (selectedMenuItem.value) {
		tab.value = 'mega_menu'
		setTimeout(() => {
			selectedMenuItem.value = null
		}, 100)
	} else {
		tab.value = 'menu'
	}
}

watch(
	() => isMobileMenuOpen.value,
	async (newValue) => {
		if (!newValue) {
			tab.value = 'menu'
		}

		if (newValue && !CMSLocations.value?.length) {
			await CMSLocationsStore.fetchCMSLocations()
		}

		if (!newValue) {
			document.body.style.overflow = 'unset'
		}
	},
)

onUnmounted(() => {
	tab.value = 'menu'
	isMobileMenuOpen.value = false
	document.body.style.overflow = 'unset'
})
</script>

<style lang="scss">
@import './Mobile';
</style>
